import React from 'react';
import Categories from './Categories';
import Volume from './VolumeTable';
import Rank from './Rank';

import styles from './standingTable.module.scss';

const StandingTable = () => (
  <div className={ styles.container } data-test="scorecardTable">
    <Categories />
    <Volume />
    <Rank />
  </div>
);

export default StandingTable;
